// GENERATED FILE — do not edit. Derived from services/api/src/entitlements.ts.
// Regenerate with: pnpm run gen:permission-catalog

export const PERMISSIONS = [
  "audit.read",
  "billing.admin",
  "billing.read",
  "device.read",
  "device.write",
  "dispatch.read",
  "dispatch.write",
  "driver.field_mode",
  "driver.read",
  "driver.write",
  "fleet.admin",
  "fleet.read",
  "fleet.write",
  "fuel.statement.self.read",
  "fuel.statement.self.write",
  "geofence.read",
  "geofence.write",
  "platform.sims.manage",
  "platform.tenants.read",
  "platform.tenants.write",
  "reporting.read",
  "telemetry.read",
  "telemetry.write",
  "tenant.admin",
  "tenant.members.read",
  "tenant.members.write",
  "tenant.read",
  "trip.read",
  "vehicle.read",
  "vehicle.write",
  "visibility.read",
  "visibility.write"
] as const;

export const ROLES = [
  {
    "id": "tenant.owner",
    "label": "Tenant Owner",
    "permissions": [
      "tenant.read",
      "tenant.admin",
      "tenant.members.write",
      "fleet.read",
      "fleet.write",
      "fleet.admin",
      "vehicle.read",
      "vehicle.write",
      "driver.read",
      "driver.write",
      "dispatch.read",
      "dispatch.write",
      "telemetry.read",
      "telemetry.write",
      "reporting.read",
      "billing.read",
      "billing.admin",
      "audit.read",
      "geofence.read",
      "geofence.write",
      "trip.read",
      "device.read",
      "device.write",
      "visibility.read",
      "visibility.write"
    ]
  },
  {
    "id": "tenant.admin",
    "label": "Tenant Admin",
    "permissions": [
      "tenant.read",
      "tenant.admin",
      "tenant.members.write",
      "fleet.read",
      "fleet.write",
      "fleet.admin",
      "vehicle.read",
      "vehicle.write",
      "driver.read",
      "driver.write",
      "dispatch.read",
      "dispatch.write",
      "telemetry.read",
      "reporting.read",
      "audit.read",
      "geofence.read",
      "geofence.write",
      "trip.read",
      "device.read",
      "device.write",
      "visibility.read",
      "visibility.write"
    ]
  },
  {
    "id": "fleet.admin",
    "label": "Fleet Admin",
    "permissions": [
      "fleet.read",
      "fleet.write",
      "fleet.admin",
      "vehicle.read",
      "vehicle.write",
      "driver.read",
      "driver.write",
      "dispatch.read",
      "dispatch.write",
      "telemetry.read",
      "telemetry.write",
      "reporting.read",
      "geofence.read",
      "geofence.write",
      "trip.read",
      "device.read",
      "device.write",
      "visibility.read",
      "visibility.write"
    ]
  },
  {
    "id": "dispatcher",
    "label": "Dispatcher",
    "permissions": [
      "fleet.read",
      "vehicle.read",
      "driver.read",
      "dispatch.read",
      "dispatch.write",
      "telemetry.read",
      "geofence.read",
      "trip.read",
      "device.read"
    ]
  },
  {
    "id": "auditor",
    "label": "Auditor",
    "permissions": [
      "fleet.read",
      "vehicle.read",
      "driver.read",
      "reporting.read",
      "audit.read",
      "geofence.read",
      "trip.read",
      "device.read",
      "telemetry.read"
    ]
  },
  {
    "id": "driver",
    "label": "Driver",
    "permissions": [
      "vehicle.read",
      "dispatch.read",
      "driver.field_mode",
      "fuel.statement.self.read",
      "fuel.statement.self.write"
    ]
  },
  {
    "id": "platform.device-gateway",
    "label": "Platform · Device Gateway",
    "permissions": [
      "telemetry.write"
    ]
  },
  {
    "id": "platform.owner",
    "label": "Platform Owner",
    "permissions": [
      "platform.tenants.read",
      "platform.tenants.write",
      "platform.sims.manage"
    ]
  }
] as const;

/**
 * Role id -> permissions, split by audience and emitted as plain literals,
 * deliberately NOT derived from `ROLES`. Two reasons, both measured in
 * apps/web's entry chunk (C-K-ENTRY1):
 *
 *  - A `ROLES.map(...)` derivation makes `ROLES` a runtime dependency of
 *    the map, so the whole catalog — every technical label too — lands in
 *    any bundle that reads permissions.
 *  - The customer app resolves tenant roles only; it checks the platform
 *    roles by id for a chip and never asks what they may do. Shipping
 *    their permissions to the browser is dead weight.
 *
 * So customer-facing code imports `TENANT_ROLE_PERMISSIONS`; code that
 * administers the platform itself imports `ROLE_PERMISSIONS`. Guarded by
 * apps/web/src/entryGraph.test.ts.
 */
export const TENANT_ROLE_PERMISSIONS: Readonly<Record<string, readonly (typeof PERMISSIONS)[number][]>> = {
  "tenant.owner": [
    "tenant.read",
    "tenant.admin",
    "tenant.members.write",
    "fleet.read",
    "fleet.write",
    "fleet.admin",
    "vehicle.read",
    "vehicle.write",
    "driver.read",
    "driver.write",
    "dispatch.read",
    "dispatch.write",
    "telemetry.read",
    "telemetry.write",
    "reporting.read",
    "billing.read",
    "billing.admin",
    "audit.read",
    "geofence.read",
    "geofence.write",
    "trip.read",
    "device.read",
    "device.write",
    "visibility.read",
    "visibility.write"
  ],
  "tenant.admin": [
    "tenant.read",
    "tenant.admin",
    "tenant.members.write",
    "fleet.read",
    "fleet.write",
    "fleet.admin",
    "vehicle.read",
    "vehicle.write",
    "driver.read",
    "driver.write",
    "dispatch.read",
    "dispatch.write",
    "telemetry.read",
    "reporting.read",
    "audit.read",
    "geofence.read",
    "geofence.write",
    "trip.read",
    "device.read",
    "device.write",
    "visibility.read",
    "visibility.write"
  ],
  "fleet.admin": [
    "fleet.read",
    "fleet.write",
    "fleet.admin",
    "vehicle.read",
    "vehicle.write",
    "driver.read",
    "driver.write",
    "dispatch.read",
    "dispatch.write",
    "telemetry.read",
    "telemetry.write",
    "reporting.read",
    "geofence.read",
    "geofence.write",
    "trip.read",
    "device.read",
    "device.write",
    "visibility.read",
    "visibility.write"
  ],
  "dispatcher": [
    "fleet.read",
    "vehicle.read",
    "driver.read",
    "dispatch.read",
    "dispatch.write",
    "telemetry.read",
    "geofence.read",
    "trip.read",
    "device.read"
  ],
  "auditor": [
    "fleet.read",
    "vehicle.read",
    "driver.read",
    "reporting.read",
    "audit.read",
    "geofence.read",
    "trip.read",
    "device.read",
    "telemetry.read"
  ],
  "driver": [
    "vehicle.read",
    "dispatch.read",
    "driver.field_mode",
    "fuel.statement.self.read",
    "fuel.statement.self.write"
  ]
};

/** Platform/machine roles. No tenant session ever carries one. */
export const PLATFORM_ROLE_PERMISSIONS: Readonly<Record<string, readonly (typeof PERMISSIONS)[number][]>> = {
  "platform.device-gateway": [
    "telemetry.write"
  ],
  "platform.owner": [
    "platform.tenants.read",
    "platform.tenants.write",
    "platform.sims.manage"
  ]
};

/** Every catalogued role. Importing this ships the platform roles too. */
export const ROLE_PERMISSIONS: Readonly<Record<string, readonly (typeof PERMISSIONS)[number][]>> = {
  ...TENANT_ROLE_PERMISSIONS,
  ...PLATFORM_ROLE_PERMISSIONS,
};
